import React, { useContext, useEffect, useState, useRef } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import BasicInfoIcon from "../svg/BasicInfo";
import AccessIcon from "../svg/AccessDetail";
import DeleteIcon from "../svg/Delete";
import ThemeContext from "../../utils/Contexts/ThemeContext";
import Constant from "../Constants";
import DeleteAccount from "./Sections/DeleteAccount";
import BasicInfo from "./Sections/BasicInfo";
import EmailSection from "./Sections/EmailSection";
import ChangePassword from "./Sections/ChangesPassword";
import SavedCards from "./Sections/SavedCards";
import Preferences from "./Sections/Preferences";
import TwoSteps from "./Sections/TwoSteps";
import RecentDevices from "./Sections/RecentDevices";
import Notification from "./Sections/Notification";
import ConnectAccount from "./Sections/ConnectAccount";
import EmailIcon from "../svg/EmailIcon";
import SavedCardIcon from "../svg/SavedCardIcon";
import PreferenceIcon from "../svg/PreferenceIcon";
import VerificationIcon from "../svg/VerificationIcon";
import DeviceIcon from "../svg/DeviceIcon";
import NotificationIcon from "../svg/NotificationIcon";
import ConnectedAccIcon from "../svg/ConnectedAccIcon";
import UserContext from "../../utils/Contexts/UserContext";
import axiosInstance from "../../utils/Requests/axios";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import AccountImage from "../../images/account-image.png";

import "./style.css"

function AccountSetting() {
  const { t } = useContext(LanguageContext);
  const { token } = useParams();

  const { themeStatus } = Constant();
  const { userData } = useContext(UserContext);
  const { selectedTheme } = useContext(ThemeContext);
  const scrollingRef = useRef(false);
  const [activeNav, setActiveNav] = useState("BasicInfo");
  const [hoverNav, setHoverNav] = useState(null);
  const [image, setImage] = useState(AccountImage);
  const [memberSince, setMemberSince] = useState(null);
  const [formLoaded, setFormLoaded] = useState(false);
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    visibility: 0,
  });
  const [email, setEmail] = useState("");
  const sections = [
    "BasicInfo",
    "EmailSection",
    "SavedCards",
    "ChangePassword",
    "Preferences",
    "TwoSteps",
    "RecentDevices",
    "Notification",
    "ConnectAccount",
    "DeleteAccount",
  ];

  useEffect(() => {
    if (token) {
      const url = `/settings/users/${userData?.uuid}/profile/email/verify/${token}`;
      axiosInstance
        .get(url)
        .then((response) => {
          toast.success(t("Email verified!"));
          setEmail(response?.data?.email);
        })
        .catch(() => {
          toast.error(t("Verification failed!"));
          // Handle error (e.g., show error message)
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const getUserProfile = () => {
    const url = `settings/users/${userData?.uuid}/profile`;
    axiosInstance
      .get(url)
      .then((response) => {
        setImage(response?.data?.image_url || AccountImage);
        setEmail(response?.data?.email || "");
        setMemberSince(response?.data?.created || null);
        setFormValues({
          first_name: response?.data?.first_name || "",
          last_name: response?.data?.last_name || "",
          phone_number: response?.data?.phone_number || "",
          visibility: response?.data?.visibility || 0,
        });
        setFormLoaded(true);
      })
      .catch((error) => {
        toast.error(t("Error fetching user data!"));
      });
  };

  const userDataFetched = useRef(false);
  useEffect(() => {
    if (userDataFetched.current) return;
    userDataFetched.current = true;
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavClick = (id) => {
    scrollingRef.current = true;
    setActiveNav(id);

    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 120,
        behavior: "smooth",
      });

      setTimeout(() => {
        scrollingRef.current = false;
      }, 800);
    }
  };

  const handleHover = (section) => {
    setHoverNav(section);
  };

  const handleHoverLeave = () => {
    setHoverNav(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.innerWidth < 992 || scrollingRef.current) return;
      let closestSection = null;
      let minDistance = Infinity;

      sections.forEach((sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          const { top, bottom } = element.getBoundingClientRect();
          if (bottom > 100 && top < window.innerHeight * 0.6) {
            // Find the section closest to the viewport center
            const distance = Math.abs(top - window.innerHeight / 3);
            if (distance < minDistance) {
              minDistance = distance;
              closestSection = sectionId;
            }
          }
        }
      });

      if (closestSection) {
        setActiveNav(closestSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    setActiveNav("BasicInfo");
    window.scrollTo(0, 0);

    let lastIsFixed = false;
    const handleScroll = () => {
      if (window.innerWidth < 992) {
        setIsFixed(false);
        return;
      }

      const shouldBeFixed = window.scrollY > 82;
      if (shouldBeFixed !== lastIsFixed) {
        setIsFixed(shouldBeFixed);
        lastIsFixed = shouldBeFixed;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <main
      id="BasicInfo"
      role="main"
      className={`main ${themeStatus?.[selectedTheme]}`}
    >
      <div className="content container-fluid">
        <div
          className="page-header pb-0 mb-4"
          style={{ borderBottom: "unset" }}
        >
          <div className="row align-items-end">
            <div className="col-sm mb-2 mb-sm-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-no-gutter">
                  <li className="breadcrumb-item">
                    {/* eslint-disable-next-line */}
                    <a href="javascript:;"
                      className="breadcrumb-link breadcrumb-text opacity-50"
                      style={{ fontSize: "18px" }}
                    >
                      {t("Account")}
                    </a>
                  </li>

                  <li
                    className="breadcrumb-item breadcrumb-text"
                    aria-current="page"
                    style={{ fontSize: "18px" }}
                  >
                    {t("Settings")}
                  </li>
                </ol>
              </nav>

              <h1
                className="page-header-title responsive-header"
                style={{ marginBottom: "unset", fontWeight: "700" }}
              >
                {t("Account Settings")}
              </h1>
            </div>
          </div>
        </div>
        <div
          className="mb-4"
          style={{
            borderBottom: `2px solid var(--border)`,
            marginLeft: "-30px",
            marginRight: "-30px",
          }}
        ></div>
        <div
          className="row d-lg-flex"
          style={{ gap: "10px", marginLeft: "auto" }}
        >
          <div className="col-lg-3 sidebar-fixed px-lg-0">
            <div className="navbar-expand-lg navbar-vertical mb-3 mb-lg-5">
              <div className="d-grid">
                <button
                  type="button"
                  className="navbar-toggler btn btn-white mb-3 rounded-1"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarVerticalNavMenu"
                  aria-label="Toggle navigation"
                  aria-expanded="false"
                  aria-controls="navbarVerticalNavMenu"
                >
                  <span className="d-flex justify-content-between align-items-center">
                    <span className="text-dark">{t("Sections")}</span>

                    <span className="navbar-toggler-default">
                      <i className="bi bi-chevron-down"></i>
                    </span>

                    <span className="navbar-toggler-toggled">
                      <i className="bi-x"></i>
                    </span>
                  </span>
                </button>
              </div>

              <div
                id="navbarVerticalNavMenu"
                className="collapse navbar-collapse rounded-3"
              >
                <ul
                  id="navbarSettings"
                  style={{
                    position: isFixed ? "fixed" : "",
                    top: isFixed && "82px",
                    border: "2px solid var(--border)",
                  }}
                  className={`js-sticky-block js-scrollspy card flex-nowrap card-navbar-nav nav nav-tabs nav-lg nav-vertical sidebar-mini-fixed d-flex flex-column justify-content-between py-lg-3`}
                >
                  {[
                    {
                      id: "BasicInfo",
                      icon: BasicInfoIcon,
                      label: t("Basic Information"),
                    },
                    {
                      id: "EmailSection",
                      icon: EmailIcon,
                      label: t("Email"),
                    },
                    {
                      id: "SavedCards",
                      icon: SavedCardIcon,
                      label: t("Saved Cards"),
                    },
                    {
                      id: "ChangePassword",
                      icon: AccessIcon,
                      label: t("Password"),
                    },
                    {
                      id: "Preferences",
                      icon: PreferenceIcon,
                      label: t("Preferences"),
                    },
                    {
                      id: "TwoSteps",
                      icon: VerificationIcon,
                      label: t("Two-step Verification"),
                    },
                    {
                      id: "RecentDevices",
                      icon: DeviceIcon,
                      label: t("Recent Devices"),
                    },
                    {
                      id: "Notification",
                      icon: NotificationIcon,
                      label: t("Notifications"),
                    },
                    {
                      id: "ConnectAccount",
                      icon: ConnectedAccIcon,
                      label: t("Connected Account"),
                    },
                    {
                      id: "DeleteAccount",
                      icon: DeleteIcon,
                      label: t("Delete Account"),
                    },
                  ].map((item) => (
                    <li className="nav-item" key={item.id}>
                      <a
                        href={`#${item.id}`}
                        className={`nav-link mb-0 d-flex${
                          item.id === "DeleteAccount"
                            ? "" // Always text-danger for DeleteAccount
                            : activeNav === item.id
                            ? "text-primary border-primary"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavClick(item.id);
                        }}
                        onMouseEnter={() => handleHover(item.id)}
                        onMouseLeave={handleHoverLeave}
                        style={{
                          color:
                            item.id === "DeleteAccount"
                              ? "#ED4C78" // Always #ED4C78 for DeleteAccount
                              : activeNav === item.id || hoverNav === item.id
                              ? "#0d6efd" // Color when active or hovered
                              : "var(--sidebar-fixed-mini)",
                          borderColor:
                            item.id === "DeleteAccount"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#ED4C78" // Border color for DeleteAccount when active
                                : "" // No border when not active
                              : activeNav === item.id || hoverNav === item.id
                              ? "#0d6efd" // Border color when active or hovered
                              : "", // No border when not active or hovered
                          marginLeft: "-0.6rem",
                          borderLeft: "0.1675rem solid transparent",
                        }}
                      >
                        <item.icon
                          fill={
                            item.id !== "DeleteAccount"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#0d6efd"
                                : "var(--sidebar-fixed-mini)"
                              : "none"
                          }
                          stroke={
                            item.id !== "DeleteAccount"
                              ? activeNav === item.id || hoverNav === item.id
                                ? "#0d6efd"
                                : "var(--sidebar-fixed-mini)"
                              : "#ED4C78"
                          }
                          style={{ marginRight: "8px" }}
                        />
                        <span
                          className="text-wrap"
                          style={{
                            fontSize: "16px",
                            fontWeight: activeNav === item.id ? "600" : "400",
                          }}
                        >
                          {item.label}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg flex-grow-1">
            <div className="d-grid gap-3 gap-lg-4">
              <BasicInfo
                formValues={formValues}
                setFormValues={setFormValues}
                image={image}
                memberSince={memberSince}
                setImage={setImage}
                formLoaded={formLoaded}
              />
              <EmailSection email={email} setEmail={setEmail} />
              <SavedCards />
              <ChangePassword />
              <Preferences />
              <TwoSteps />
              <RecentDevices />
              <Notification />
              <ConnectAccount />
              <DeleteAccount />
            </div>
            <div id="stickyBlockEndPoint"></div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AccountSetting;
